import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface ConversationFilters {
  status: "all" | "draft" | "closed" | "solved" | "open";
  type: "all" | "circle_bot" | "live_chat" | "email";
}

export const useListConversations = ({ type, status }: ConversationFilters) => {
  const listConversations = () =>
    reactQueryGet(
      internalApi.supportWidget.listConversationsV2({
        conversationFilters: {
          channel_type: type,
          status,
        },
      }),
    );

  return useQuery(["conversations_v2", type, status], listConversations);
};
